import React from 'react';
import { useFieldArray, Controller } from 'react-hook-form';
import { Input, Label } from '../common';
import { PlainButton } from '../common/ButtonsV2';
import AddButton from './AddButton';
import DeleteIcon from './Icons/DeleteIcon';

/**
 * FieldArray para asignar múltiples Device Units (MAC addresses)
 * - `deviceIdentifiers` es un array de strings en el form.
 */
const DeviceUnitsField = ({ control, errors }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'deviceIdentifiers',
  });

  return (
    <div className="mt-2">
      <Label variant="gray">Device Identifiers</Label>
      {fields.map((field, idx) => {
        return (
          <div key={field.id} className="flex items-center gap-2 mt-2">
            <Controller
              control={control}
              name={`deviceIdentifiers.${idx}`}
              rules={{
                pattern: {
                  value: /^([A-F0-9]{2}:){5}[A-F0-9]{2}$/i,
                  message: 'Invalid MAC-style identifier',
                },
              }}
              render={({ field }) => (
                <div className="flex w-full">
                  <Input
                    {...field}
                    variant="primary"
                    customClass="!max-w-full flex-1"
                    placeholder="AA:BB:CC:DD:EE:FF"
                  />

                  {fields.length > 1 && (
                    <PlainButton
                      customClass="shadow-none"
                      type="button"
                      onClick={() => remove(idx)}
                      aria-label="Remove"
                    >
                      <DeleteIcon color="black" />
                    </PlainButton>
                  )}
                </div>
              )}
            />
          </div>
        );
      })}
      <div className="flex items-center mt-3">
        <AddButton onClick={() => append('')} /> <p className="ml-1">Add Device unit</p>
      </div>

      {/* error global del array */}
      {errors.deviceIdentifiers?.root && (
        <p className="text-error mt-1">{errors.deviceIdentifiers.root.message}</p>
      )}
    </div>
  );
};

export default DeviceUnitsField;
